import TransactionIndex from "../../pages/dashboard/transaction";
import BusinessTransactionIndex from "../../pages/dashboard/transaction/BusinessTransactions";
import QueuingTransaction from "../../pages/dashboard/transaction/QueuingTransaction";
import TransactionDetails from "../../pages/dashboard/transaction/transactionDetails";
import WebTransactionIndex from "../../pages/dashboard/transaction/WebTransactions";
import ZojapayTransaction from "../../pages/dashboard/transaction/ZojapayTransactions";
import BridgeTransaction from "../../pages/dashboard/transaction/BridgeTransactions";
import StripeTransaction from "../../pages/dashboard/transaction/StripeTransactions";
import PlaidTransaction from "../../pages/dashboard/transaction/PlaidTransactions";
import { ALL_ROUTES } from "../AllRoutes";

export const transaction_route_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_DETAILS,
    element: TransactionDetails,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_MOBILE,
    element: TransactionIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_WEB,
    element: WebTransactionIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_BUSINESS,
    element: BusinessTransactionIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_QUEUING,
    element: QueuingTransaction,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_ZOJAPAY,
    element: ZojapayTransaction,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_BRIDGE,
    element: BridgeTransaction,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_STRIPE,
    element: StripeTransaction,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_TRANSACTION_PLAID,
    element: PlaidTransaction,
  },
];
